import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import DahamSchoolView from "@/views/DahamSchoolView.vue";
import EventsView from "@/views/EventsView.vue";
import GalleryView from "@/views/GalleryView.vue";
import ContactView from "@/views/ContactView.vue";
import DonationsView from "@/views/DonationsView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },

  {
    path: "/dahamschool",
    name: "DahamSchool",
    component: DahamSchoolView,
  },

  {
    path: "/events",
    name: "Events",
    component: EventsView,
  },

  {
    path: "/gallery",
    name: "Gallery",
    component: GalleryView,
  },

  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },

  {
    path: "/donations",
    name: "Donations",
    component: DonationsView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
